(function () {
    'use strict';

    angular
        .module('app')
        .controller('SmsViewDialogCtrl', SmsViewDialogCtrl);

    SmsViewDialogCtrl.$inject = ['$q', 'DialogInstance', 'EntitiesService', 'sms'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing bulk-mode compose SMS previews.
     */
    function SmsViewDialogCtrl($q, DialogInstance, EntitiesService, sms) {
        /* jshint validthis:true */
        var vm = this;
        vm.previewEntityId = null;
        vm.fromEntities = [];
        vm.loading = true;
        vm.close = close;
        vm.previewEntityChanged = previewEntityChanged;

        activate();

        function activate() {
            var loadPromises = [];

            if (!_.isNil(sms.data.From) && sms.data.From !== '') {
                angular.forEach(sms.data.From, function (fromEntityId) {
                    loadPromises.push(loadEntity(fromEntityId));
                });
            } else if (!_.isNil(sms.data.FromEntityId) && sms.data.FromEntityId !== '') {
                loadPromises.push(loadEntity(sms.data.FromEntityId));
            } else {
                vm.error = 'SMS details could not be loaded. Related entity could not be determined.';
            }

            $q.all(loadPromises)
                .then(function () {
                        vm.fromEntities = orderEntities(vm.fromEntities, vm.fromEntities[0].EntityTemplate);
                        vm.previewEntityId = vm.fromEntities[0].Id;

                        return previewEntityChanged();
                    });
        }

        /**
         * When the selected preview entity is changed, the SMS preview must be updated.
         */
        function previewEntityChanged() {
            vm.loading = true;

            return loadSMSPreview()
                .then(function () {
                    vm.loading = false;
                });
        }

        /**
         * Load SMS preview for vm.previewEntityId.
         */
        function loadSMSPreview() {
            return sms.getPreview(vm.previewEntityId).then(getPreviewOk, getPreviewError);

            function getPreviewOk(smsPreview) {
                smsPreview.data.Tags = sms.data.Tags;
                vm.smsPreview = smsPreview;
            }

            function getPreviewError(response) {
                vm.error = 'Unable to load SMS preview.';
            }
        }

        /**
         * Load from entity for the supplied id.
         *
         * @param {int} entityId - Identifier for an entity.
         */
        function loadEntity(entityId) {
            return EntitiesService.get(entityId).then(getEntityOk);

            function getEntityOk(data) {
                vm.fromEntities.push(data);
            }
        }

        /**
         * Get the ordered list of entities.
         *
         * @param {array} entities - List of entities which are to be ordered.
         * @param {object} entityTemplate - Entity template to be used for ordering the entities.
         * @return {array} Return a list of ordered entities.
         */
        function orderEntities(entities, entityTemplate) {
            if (!_.isNil(entityTemplate.OrderSetting) && !_.isNil(entityTemplate.OrderSetting.Default)) {
                var orderOption = _.find(entityTemplate.OrderSetting.Options, function (option) {
                    return option.Name === entityTemplate.OrderSetting.Default;
                });

                if (!_.isNil(orderOption)) {
                    var orderFieldList = [];
                    var orderDirectionList = [];

                    angular.forEach(orderOption.Fields, function (field) {
                        if (!_.isNil(field.Name) && field.Name !== '') {
                            orderFieldList.push(field.Name.replace('fields|', 'Fields.'));
                            orderDirectionList.push(field.Order);
                        }
                    });

                    entities = _.sortByOrder(entities, orderFieldList, orderDirectionList);
                }
            }

            return entities;
        }

        function close() {
            DialogInstance.ok();
        }
    }
})();
